import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { AppService } from '@/lib/services/AppService'

const appService = new AppService()

export const useLoadStatus = () =>
  useQuery({
    queryKey: ['fetchStatus'],
    queryFn: async () => appService.getStatus(),
    select: (response) => response.data,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    retry: false,
  })

export const statusSubscriptionQueryKey = ['statusSubscription'] as const

export const useStatusPageSubscription = (enabled: boolean) =>
  useQuery({
    queryKey: statusSubscriptionQueryKey,
    queryFn: async () => {
      const res = await appService.getStatusSubscription()
      return res.data
    },
    enabled,
    staleTime: 30_000,
    retry: false,
  })

export const useSubscribeStatusPage = () => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: () => appService.subscribeStatusPage(),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: statusSubscriptionQueryKey })
    },
  })
}

export const useUnsubscribeStatusPage = () => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: () => appService.unsubscribeStatusPage(),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: statusSubscriptionQueryKey })
    },
  })
}
